import { MapSearchResult } from 'hooks/useMapSearch/useMapSearch.types';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { getRegionName } from 'shared/utils';

export const geoEventToMapSearchResult = (
  geoEvent: Wildfire,
): MapSearchResult => {
  return {
    id: geoEvent.id.toString(),
    type: 'GeoEvent',
    text: geoEvent.name,
    placeName: getRegionName(geoEvent.regions),
    center: [geoEvent.lng, geoEvent.lat],
    original: geoEvent,
  };
};
